/**
 * Global State
 *
 * Re-exports atoms from domain modules for backward compatibility.
 * New code can import directly from services/atoms/*.
 */

export { store } from './store';

export {
  authenticatedUserIdAtom,
  authStateResolvedAtom,
  createAccountAtom,
  actAsUserIdAtom,
  userIdAtom,
  redirectAfterConfirmationAtom,
} from './atoms/auth';

export { communityShowAuthModalAtom, selectedCancerFocusAtom } from './atoms/community';

export {
  tabSelectedKeyAtom,
  inquiryCloseAtom,
  isFeedbackActiveAtom,
  type InquiryCloseStatus,
  type InquiryCloseState,
  type InquiryCloseAction,
  type NavigationTarget,
} from './atoms/inbox';

export { isOnlineAtom, showWarningToastAtom } from './atoms/network';

export { productSupportPrefillMessageAtom } from './atoms/productSupport';
